import { IconCalendarEvent } from '@tabler/icons-react';

import { Avatar, ThemeIcon } from '@optiro/ui';

import { UserAvatar } from '@/components/UserAvatar';

import { CategoryConfig, NotificationCategory, NotificationType } from './notifications.types';

export function NotificationIcon({
  n,
  category,
  config,
}: {
  n: NotificationType;
  category: NotificationCategory;
  config: CategoryConfig;
}) {
  // For task assignments, show the sender's avatar
  if (category === 'action' && n.type === 'TaskNotifier::Notification') {
    return (
      <Avatar.Group>
        <UserAvatar userId={n.params.assigned_by.id} />
      </Avatar.Group>
    );
  }

  // For reminders — project start gets a calendar, timesheet gets a clock
  if (n.type === 'ProjectStartReminderNotifier::Notification') {
    return (
      <ThemeIcon variant="light" color={config.color} size="lg" radius="xl">
        <IconCalendarEvent size={18} />
      </ThemeIcon>
    );
  }

  // Default: use category icon
  return (
    <ThemeIcon variant="light" color={config.color} size="lg" radius="xl">
      {config.icon}
    </ThemeIcon>
  );
}
